import React from "react";
import { TwilioPhone } from "@whatslly/types/twilio/TwilioGetPhones";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import { TFunction } from "i18next";

export const getTwilioCapabilities = (t: TFunction, phone: Partial<TwilioPhone>) => {
  return [
    phone.capabilities?.voice && {
      label: <SvgV2 iconName="voice" width={15} height={15} />,
      description: t("twilio_settings_page.cols.voice"),
    },
    phone.capabilities?.sms && {
      label: <SvgV2 iconName="sms" width={15} height={15} />,
      description: t("twilio_settings_page.cols.sms"),
    },
  ].filter(Boolean) as { label: React.ReactNode }[];
};
